import type { GameConfig } from '../types/GameConfig';

export class GameState {
  playerCookies: number;
  trashCount: number = 0;
  monstersPlaced: number = 0;
  totalCookiesEaten: number = 0;
  isGameOver: boolean = false;

  private readonly cfg: Pick<GameConfig, 'monsterBaseCost' | 'monsterCostMultiplier' | 'trashCanCapacity'>;

  constructor(cfg: GameState['cfg'], startingCookies: number) {
    this.cfg = cfg;
    this.playerCookies = startingCookies;
  }

  get nextMonsterCost(): number {
    return Math.ceil(
      this.cfg.monsterBaseCost * Math.pow(this.cfg.monsterCostMultiplier, this.monstersPlaced)
    );
  }

  canAffordMonster(): boolean {
    return !this.isGameOver && this.playerCookies >= this.nextMonsterCost;
  }

  eatCookie(): void {
    this.playerCookies += 1;
    this.totalCookiesEaten += 1;
  }

  // Returns true if the trash can is now full (game over)
  trashCookie(): boolean {
    this.trashCount += 1;
    if (this.trashCount >= this.cfg.trashCanCapacity) {
      this.isGameOver = true;
    }
    return this.isGameOver;
  }

  buyMonster(): void {
    this.playerCookies -= this.nextMonsterCost;
    this.monstersPlaced += 1;
  }
}
